import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

import { useHistory } from 'react-router-dom';
import styles from './Header.module.scss';
import ICONS from '../../static/media/icons/icons-helper';

const menuButtonAnimationState = {
  opened: [
    { rotate: 45, y: 5, x: 0 },
    { rotate: -45, y: -5, x: 0 },
  ],
  closed: [
    { rotate: 0, y: 0, x: 0 },
    { rotate: 0, y: 0, x: 0 },
  ],
};

const Header = ({ onMenuClick, isSideMenuOpened }) => {
  const history = useHistory();

  const gotoRoot = () => history.push('/');

  return (
    <div className={styles.headerContainer}>
      <img
        className={styles.arrowIcon}
        src={ICONS.LOGO}
        alt="logo-img"
        onClick={gotoRoot}
      />
      <div onClick={onMenuClick} className={styles.menuWrapper}>
        <motion.div
          className={styles.menuLine}
          animate={
            isSideMenuOpened
              ? menuButtonAnimationState.opened[0]
              : menuButtonAnimationState.closed[0]
          }
        />
        <motion.div
          className={styles.menuLine}
          animate={
            isSideMenuOpened
              ? menuButtonAnimationState.opened[1]
              : menuButtonAnimationState.closed[1]
          }
        />
      </div>
    </div>
  );
};

Header.propTypes = {
  onMenuClick: PropTypes.func.isRequired,
  isSideMenuOpened: PropTypes.bool.isRequired,
};

export default Header;
